import axios from "axios";
import { API_URL } from "../../config";

export function authHeaders() {
  return { Authorization: `Bearer ${localStorage.getItem("access_token")}` };
}

// The flat fee tiers in words, as the backend states them
// (e.g. "$50 under $1K, ..."), or null when they can't be loaded.
export async function fetchFeeTiersText() {
  try {
    const { data } = await axios.get(`${API_URL}/book-it/admin/fee-tiers`, {
      headers: authHeaders(),
    });
    return data?.text || null;
  } catch {
    return null;
  }
}

// The backend's fee for one booking at a given rate ({ fee_cents, charged }),
// or null when it can't be quoted.
export async function fetchFeeQuote(bookingRequestId, rateCents) {
  try {
    const { data } = await axios.get(`${API_URL}/book-it/admin/fee-tiers`, {
      headers: authHeaders(),
      params: { booking_request_id: bookingRequestId, rate_cents: rateCents },
    });
    return data?.fee_cents != null ? data : null;
  } catch {
    return null;
  }
}

// "by load amount ($50 under $1K, ...)", or just "by load amount" without
// the tiers so ops never see amounts the backend didn't send.
export function feeByLoadAmount(tiersText) {
  return tiersText ? `by load amount (${tiersText})` : "by load amount";
}

export function usd(cents) {
  return `$${(cents / 100).toFixed(2)}`;
}

// A row's fee as the backend previews it: the charged amount, 0 when it
// books on a free credit, or the tier for its rate.
export function feeCellText(row) {
  if (row.fee_preview_cents == null) return "—";
  return row.fee_preview_cents === 0
    ? "Free credit"
    : usd(row.fee_preview_cents);
}
